import { isPdfPrintPath } from '@/utils/pdfPrint.utils';

interface ICookieConsentBannerEnv {
  DEV: boolean;
  VITE_ENABLE_COOKIE_CONSENT_BANNER?: string;
}

export function shouldDisableCookieConsentBannerForPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;

  return isPdfPrintPath(pathname);
}

export function parseCookieConsentBannerOverride(rawValue: string | null | undefined): boolean | null {
  if (!rawValue) return null;

  const normalizedValue = rawValue.trim().toLowerCase();

  if (!normalizedValue) return null;

  if (['1', 'true', 'yes', 'on'].includes(normalizedValue)) {
    return true;
  }

  if (['0', 'false', 'no', 'off'].includes(normalizedValue)) {
    return false;
  }

  return null;
}

export function shouldEnableCookieConsentBanner(env: ICookieConsentBannerEnv): boolean {
  const override = parseCookieConsentBannerOverride(env.VITE_ENABLE_COOKIE_CONSENT_BANNER);

  if (override !== null) {
    return override;
  }

  return !env.DEV;
}
